// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yx-widget/component/YxModal/Modal/index.less
// module id = ./src/yx-widget/component/YxModal/Modal/index.less
// module chunks = 43